import {HTTP} from "@/http";

class AdminCustomerService {
  /**
   * Get all customers across all tenants (for Super Admins)
   * This endpoint is in the TenantAdminController
   * @param {Object} filterParams - Filter parameters
   * @param {string} filterParams.search - Optional search term
   * @param {Object} pageParams - Pagination parameters
   * @param {number} pageParams.page - Page number (0-based)
   * @param {number} pageParams.pageSize - Page size
   * @returns {Promise<Object>} Promise that resolves to the customers response
   */
  getAllCustomers(filterParams = {}, pageParams = {}) {
    const params = {
      ...filterParams,
      ...pageParams
    };

    return HTTP.get('api/v2/admin/tenants/customers', { params });
  }

  /**
   * Get customers for a specific tenant
   * @param {string} tenantId - The tenant ID
   * @param {Object} filterParams - Filter parameters
   * @param {Object} pageParams - Pagination parameters
   * @returns {Promise<Object>} Promise that resolves to the customers for the tenant
   */
  getCustomersByTenant(tenantId, filterParams = {}, pageParams = {}) {
    const params = {
      ...filterParams,
      ...pageParams
    };

    return HTTP.get(`api/v2/admin/tenants/${tenantId}/customers`, { params });
  }

  /**
   * Create a customer for a specific tenant
   * @param {string} tenantId - The tenant ID
   * @param {Object} customer - The customer to create
   * @returns {Promise<Object>} Promise that resolves to the created customer
   */
  createCustomerForTenant(tenantId, customer) {
    return HTTP.post(`api/v2/admin/tenants/${tenantId}/customers`, customer);
  }

  /**
   * Delete a customer from a tenant
   * @param {string} tenantId - The tenant ID
   * @param {string} customerId - The customer ID to delete
   * @returns {Promise<Object>} Promise that resolves when the customer is deleted
   */
  deleteCustomerFromTenant(tenantId, customerId) {
    return HTTP.delete(`api/v2/admin/tenants/${tenantId}/customers/${customerId}`);
  }
}

/**
 * @type {AdminCustomerService}
 */
export const adminCustomerService = new AdminCustomerService();
